<div class="attendee-list">
  <div class="attendee-list-header">
    <h2>{{ 'MEETING_SCHEDULER.ATTENDEE_LIST.TITLE' | translate }}</h2>
    <button class="export-button" mat-icon-button [glxyTooltip]="'MEETING_SCHEDULER.ATTENDEE_LIST.EXPORT' | translate">
      <mat-icon>download</mat-icon>
    </button>
  </div>

  <div class="attendee-list-filters">
    <glxy-form-field class="search-field">
      <mat-icon class="search-icon" matPrefix>search</mat-icon>
      <input
        matInput
        [(ngModel)]="searchTerm"
        (ngModelChange)="onSearchChange()"
        [placeholder]="'MEETING_SCHEDULER.ATTENDEE_LIST.SEARCH_PLACEHOLDER' | translate"
      />
    </glxy-form-field>
  </div>

  <div class="attendee-list-content">
    <ng-container *ngIf="filteredAttendees.length > 0; else noAttendees">
      <mat-accordion>
        <ng-container *ngFor="let attendee of filteredAttendees; let i = index; trackBy: trackByAttendeeId">
          <mat-expansion-panel class="expansion-panel">
            <mat-expansion-panel-header class="expansion-panel-header">
              <mat-panel-title class="expansion-panel-title">
                <div class="attendee-header">
                  <div class="attendee-name">
                    {{ attendee.name }}
                  </div>
                  <div class="attendee-actions">
                    <button
                      mat-icon-button
                      (click)="onDeleteAttendee(attendee.id, $event)"
                      [glxyTooltip]="'MEETING_SCHEDULER.ATTENDEE_LIST.DELETE' | translate"
                    >
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <ng-container [ngTemplateOutlet]="attendeeDetailsGrid" [ngTemplateOutletContext]="{ $implicit: attendee }">
            </ng-container>
          </mat-expansion-panel>
        </ng-container>
      </mat-accordion>
    </ng-container>
  </div>
</div>

<!-- Attendee Details Grid Template -->
<ng-template #attendeeDetailsGrid let-attendee>
  <div class="attendee-details-container">
    <!-- First Row: Email and Phone -->
    <div class="attendee-details-row">
      <div class="grid-item">
        <div class="attendee-subtitle">
          {{ 'MEETING_SCHEDULER.ATTENDEE_LIST.EMAIL_LABEL' | translate }}
        </div>
        <div class="comment">{{ attendee?.email || '—' }}</div>
      </div>
      <div class="grid-item" *ngIf="attendee?.phoneNumber">
        <div class="attendee-subtitle">
          {{ 'MEETING_SCHEDULER.ATTENDEE_LIST.PHONE_LABEL' | translate }}
        </div>
        <div class="comment">{{ attendee?.phoneNumber || '—' }}</div>
      </div>
    </div>

    <!-- Second Row: Comments -->
    <div class="attendee-details-row">
      <div class="grid-item full-width">
        <div class="attendee-subtitle">
          {{ 'MEETING_SCHEDULER.ATTENDEE_LIST.COMMENTS_LABEL' | translate }}
        </div>
        <div class="comment">{{ attendee?.comments || '—' }}</div>
      </div>
    </div>

    <!-- Third Row: Custom Questions -->
    <div class="attendee-details-row" *ngIf="attendee?.customQuestions && attendee.customQuestions.length > 0">
      <div class="grid-item full-width">
        <div class="attendee-subtitle">
          {{ 'MEETING_SCHEDULER.ATTENDEE_LIST.CUSTOM_QUESTIONS_LABEL' | translate }}
        </div>
        <div class="custom-questions-container">
          <div class="question-item" *ngFor="let question of attendee.customQuestions">
            <div class="question-label">{{ question.label }}</div>
            <div class="question-answer">{{ question.answer || '—' }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- No Attendees Template -->
<ng-template #noAttendees>
  <mat-card appearance="outlined">
    <mat-card-content>
      <div class="empty-state-container">
        <div class="empty-state-content">
          <mat-icon class="empty-state-icon">people</mat-icon>
          <h3 class="empty-state-title">
            {{ 'MEETING_SCHEDULER.ATTENDEE_LIST.EMPTY_STATE.TITLE' | translate }}
          </h3>
          <p class="empty-state-description">
            {{ 'MEETING_SCHEDULER.ATTENDEE_LIST.EMPTY_STATE.DESCRIPTION' | translate }}
          </p>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</ng-template>
